import React, { useState, useEffect } from "react";
import { fetchTeachersData } from "../../../../services/homeContentService";
import { Box, Heading } from "@chakra-ui/react";
import EditTeacher from "./components/EditTeachers";
import { useUser } from "@clerk/clerk-react";
import AdminNavbar from "../../../../components/navbars/adminNavbar/adminNavbar";
import AddTeachers from "./components/addTeachers";

const TeachersProfilePanel = () =>{

    const [teachersProfile, setTeachersProfile] = useState([]);
    const {user} = useUser();

    useEffect(() =>{
        const loadTeachers = async() =>{
          const data = await fetchTeachersData();
          setTeachersProfile(data);
        };
        loadTeachers();
      }, []);

      return(
        <Box p={4}>
        <AdminNavbar />
        <AddTeachers clerkId={user.id}/>
        <Heading as='h3' mt={4} >Edit teachers profile</Heading>
        {teachersProfile.map((teacher) => (
            <EditTeacher key={teacher.id} teacher={teacher} clerkId={user.id}/>
          ))}
        </Box>
      )

}

export default TeachersProfilePanel;